import { TextAlignment } from '../../../__generated__/globalTypes'

import {
  TextFragmentFragment,
  isTextFragmentFragment,
} from './TextFragmentFragment'

import paragraphFragmentRawString from '../ParagraphFragment.graphql'

export const paragraphFragmentString = paragraphFragmentRawString

export type ParagraphFragment = {
  __typename: 'Paragraph'
  textFragments: TextFragmentFragment[]
  alignment: TextAlignment
}

export const isParagraphFragment = (
  fragment: any,
): fragment is ParagraphFragment =>
  fragment &&
  fragment.__typename === 'Paragraph' &&
  Array.isArray(fragment.textFragments) &&
  fragment.textFragments
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) =>
        accum && (isTextFragmentFragment(next) as boolean),
      true,
    ) &&
  (fragment.alignment === 'LEFT' ||
    fragment.alignment === 'CENTER' ||
    fragment.alignment === 'RIGHT')
